import clsx from 'clsx'
import Typography from 'components/Common/Typography'
import SlippageInput from 'components/SlippageInput/SlippageInput'
import { DEFAULT_SLIPPAGE_AMOUNT } from 'config/factors'
import { useState } from 'react'

const visibleSlippagePercentages = [
  { label: '0.1', value: 10 },
  { label: '0.2', value: 20 },
  { label: '0.3', value: 30 },
  { label: '0.4', value: 40 },
]

const SlippagePercentageSelector = ({
  slippagePercentage,
  changeSlippagePercentage,
}: {
  slippagePercentage: number
  changeSlippagePercentage: (val: number) => void
}) => {
  const [isEditing, setIsEditing] = useState(false)

  return (
    <div className="flex h-8 items-center gap-2.5">
      {visibleSlippagePercentages.map((el, idx) => {
        return (
          <div
            key={idx}
            className={clsx(
              'flex h-full flex-1 items-center justify-center rounded border border-patek-neutral-celestial-grey-800',
              el.value === slippagePercentage
                ? 'bg-patek-neutral-celestial-grey-900'
                : 'cursor-pointer bg-transparent',
            )}
            onClick={() => {
              changeSlippagePercentage(el.value)
              setIsEditing(false)
            }}
          >
            <Typography
              font="font-number"
              className={clsx(
                'text-xs font-semibold fhd:text-sm',
                el.value === slippagePercentage
                  ? 'text-white'
                  : 'text-patek-neutral-celestial-grey-600',
              )}
            >{`${el.label}%`}</Typography>
          </div>
        )
      })}
      {isEditing ? (
        <div className="h-full flex-1">
          <SlippageInput
            // setAllowedSlippage={changeSlippagePercentage}
            defaultSlippage={DEFAULT_SLIPPAGE_AMOUNT}
            largeSize={true}
          />
        </div>
      ) : (
        <div
          className="ml-4 flex h-full cursor-pointer items-center justify-center rounded border border-patek-neutral-celestial-grey-800 bg-patek-neutral-celestial-grey-900 px-4"
          onClick={() => {
            setIsEditing(true)
            changeSlippagePercentage(DEFAULT_SLIPPAGE_AMOUNT)
          }}
        >
          <span className="text-xs font-semibold text-th-active fhd:text-sm">
            Custom
          </span>
        </div>
      )}
    </div>
  )
}

export default SlippagePercentageSelector
